export const screenWidths = {
  phone: 460,
  tablet: 992,
  desktopXl: 1280,
};

export const isMobile = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const width = window.innerWidth ?? window.screen?.width;

  return width <= screenWidths.phone;
}

export const isTablet = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const width = window.innerWidth ?? window.screen?.width;

  return screenWidths.phone < width && width <= screenWidths.tablet;
}

export const isDesktopXl = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  const width = window.innerWidth ?? window.screen?.width;

  return width >= screenWidths.desktopXl;
}
